import React from "react";

import cn from "classnames";
import { useIntl } from "react-intl";

import RoundButton from "@app/component/RoundButton";
import TimelineViewFilter, {
  getTimelineTypeFilterDisplayName,
} from "@app/scene/dashboard/enum/TimelineViewFilter";

import styles from "./TypeSelector.module.scss";

interface Props {
  className?: string;
  onChange?: (value?: TimelineViewFilter) => void;
  value?: TimelineViewFilter;
}

const TypeSelector: React.FC<Props> = ({ className, onChange, value }) => {
  const intl = useIntl();

  return (
    <div className={cn(styles.container, className)}>
      {[
        TimelineViewFilter.ALL,
        TimelineViewFilter.CHECK_INS,
        TimelineViewFilter.ACTIVITIES,
        TimelineViewFilter.MENTIONS,
        TimelineViewFilter.NEW_RECORDS,
        TimelineViewFilter.ROUTES,
        TimelineViewFilter.DEALS,
      ].map((filter) => (
        <RoundButton
          active={filter === value || (filter === TimelineViewFilter.ALL && !value)}
          className={styles.button}
          key={filter}
          onClick={() => onChange?.(filter === TimelineViewFilter.ALL ? undefined : filter)}
        >
          {getTimelineTypeFilterDisplayName(intl, filter)}
        </RoundButton>
      ))}
    </div>
  );
};

export default TypeSelector;
